import React from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import $ from 'jquery';

import './index.scss';

export default class CreditCardNumberInput extends React.Component {
  static displayName = 'CreditCardNumberInput';
  static propTypes = {
    name: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
  };
  static defaultProps = {
    name: 'card_number',
    ref: 'creditCardNumber',
    value: null,
    placeholder: 'Credit card number',
    disabled: false,
  };

  componentDidMount() {
    $(this._inputDOM()).payment('formatCardNumber');
  }

  _inputDOM() {
    return findDOMNode(this.refs[this.props.ref]);
  }

  render() {
    const attrs = {
      type: 'text',
      name: this.props.name,
      ref: this.props.ref,
      value: this.props.value,
      disabled: this.props.disabled,
      placeholder: this.props.placeholder,
      onChange: this.props.onChange,
    };

    return <input className="CreditCardNumberInput fs-hide" {...attrs} />;
  }
}
